import React, { useContext, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import Grid from '@mui/material/Grid';
import { makeStyles } from '@mui/styles';

import LoadingChoiceModal from '../components/LoadingChoiceModal';
import DownloadLogButton from '../components/PrintLogButton';
import ChillerFormSpreadsheet from '../components/ChillerFormSpreadsheet';
import PreviousLogDialog from '../components/PreviousLogDialog';
import SaveTimeInfo from '../components/SaveTimeInfo';
import ChillerBackButton from '../components/ChillerBackButton';
import SubmissionButtons from '../components/SubmissionButtons';
import ChillerFormChangeHistory from '../components/ChillerFormChangeHistory';

import { minimumLoading } from '../../../utils/minimumLoading';

import { ChillerLogsContext } from '../contexts/ChillerLogsContext';
import { AuthenticationContext } from '../../../homeModules/auth/contexts/AuthenticationContext';

const useStyles = makeStyles(() => ({
  root: {
    minHeight: '100vh',
    width: '100%',
    padding: '20px',
  },
  stepContent: {
    marginTop: '20px',
    marginBottom: '20px',
  },
}));

const UpcomingJobDetail: React.FunctionComponent = () => {
  const classes = useStyles();
  const { id } = useParams<{ id: string }>();

  const { jobSpreadsheetPageLoad, setLogId, chillerLog } = useContext(ChillerLogsContext);
  const { user, isAdminUser, isApprover, fetchUser } = useContext(AuthenticationContext);

  let showChangeHistory =
    (isAdminUser || isApprover) && ['pending_approval', 'complete_no_log', 'complete'].includes(chillerLog?.status);

  useEffect(() => {
    if (fetchUser) {
      fetchUser();
    }
    if (user && id) {
      setLogId(id);
      jobSpreadsheetPageLoad(id);
    }
  }, [id, user]);

  return (
    <Grid container className={classes.root} style={{ marginLeft: -200 }}>
      <PreviousLogDialog />
      <LoadingChoiceModal />
      <Grid item xs={11} md={3}>
        <ChillerBackButton />
      </Grid>
      <Grid xs={1} md={6} />
      <Grid item xs={11} md={3}>
        <DownloadLogButton chillerId={chillerLog?.id} />
      </Grid>
      <Grid item xs={12} style={{ marginTop: 20 }}>
        {chillerLog ? <ChillerFormSpreadsheet /> : <p>Loading...</p>}
      </Grid>
      <Grid item xs={12} style={{ marginLeft: -30 }}>
        <SubmissionButtons />
      </Grid>

      <Grid item xs={12} style={{ display: 'flex', justifyContent: 'flex-end', padding: 0, maxWidth: 'unset' }}>
        <SaveTimeInfo />
      </Grid>
      {showChangeHistory && (
        <Grid item xs={12} style={{ marginLeft: -30, marginTop: 15, width: 1400 }}>
          <ChillerFormChangeHistory />
        </Grid>
      )}
    </Grid>
  );
};

export default UpcomingJobDetail;
